/* Probably Late — polaroid bounce cards
   Vanilla GSAP adaptation of the React Bits <BounceCards /> effect:
   - cards elastically scale in (staggered) when the section enters view
   - hovering a card flattens its rotation while siblings get pushed
     aside, with a small distance-based delay; leaving resets the pile.
   Runs on DOMContentLoaded so GSAP (deferred later in the document)
   is guaranteed to be loaded. */
(function () {
  window.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.pl-polaroids');
    if (!container || !window.gsap) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    var cards = Array.prototype.slice.call(container.querySelectorAll('.pl-polaroids__item'));
    if (!cards.length) return;

    var isMobile = window.matchMedia('(max-width: 1099px)').matches;
    var canHover = window.matchMedia('(hover: hover)').matches;

    var EASE_IN = 'elastic.out(1, 0.5)';
    var EASE_HOVER = 'back.out(1.4)';

    // Take over the transform from CSS: same placement, but GSAP-owned
    // so scale/rotation/x can animate without clobbering the centering
    cards.forEach(function (card) {
      var rot = parseFloat(card.getAttribute('data-rot') || '0');
      // Mobile swipe row uses half rotation (matches the CSS resting state)
      if (isMobile) rot = rot / 2;
      var base = { rotation: rot, scale: 0 };
      if (!isMobile) {
        base.xPercent = -50;
        base.yPercent = -50;
      }
      gsap.set(card, base);
    });

    // Entrance: staggered elastic pop once most of the section is in view.
    // The pointer is locked out until the pop fully settles so hovering
    // mid-animation can't disturb the cards.
    var played = false;
    var entranceDone = false;
    container.style.pointerEvents = 'none';

    function playEntrance() {
      if (played) return;
      played = true;
      gsap.to(cards, {
        scale: 1,
        stagger: 0.15,
        ease: EASE_IN,
        delay: 0.2,
        duration: 1,
        onComplete: function () {
          entranceDone = true;
          container.style.pointerEvents = '';
        }
      });
    }

    if ('IntersectionObserver' in window) {
      // Fire as soon as the section is meaningfully in view. A ratio-based
      // threshold is unreliable here: the section is taller than the
      // viewport on smaller screens, so a fixed ratio can never be met and
      // the cards would sit at scale 0 forever. rootMargin trims the bottom
      // so it still waits until the scene is properly on screen.
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              playEntrance();
              observer.disconnect();
            }
          });
        },
        { rootMargin: '0px 0px -25% 0px' }
      );
      observer.observe(container);
    } else {
      playEntrance();
    }

    // Last resort: never leave the cards invisible. If the entrance somehow
    // hasn't run once the section is on screen, show them outright.
    setInterval(function () {
      if (played) return;
      var r = container.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) playEntrance();
    }, 1500);

    // Tap a polaroid to give it a small shake (phone only — checked at tap
    // time so rotating the device or resizing doesn't strand the listener)
    var mobileQuery = window.matchMedia('(max-width: 1099px)');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (!mobileQuery.matches) return;
        card.classList.remove('is-shaking');
        // reflow so the animation can restart on rapid repeat taps
        void card.offsetWidth;
        card.classList.add('is-shaking');
      });
      card.addEventListener('animationend', function () {
        card.classList.remove('is-shaking');
      });
    });

    // Hover: straighten the hovered card, gently push the rest aside
    if (!canHover || isMobile) return;

    function pushSiblings(hoveredIdx) {
      if (!entranceDone) return;
      var pushX = container.getBoundingClientRect().width * 0.032;
      cards.forEach(function (card, i) {
        gsap.killTweensOf(card);
        if (i === hoveredIdx) {
          gsap.to(card, { rotation: 0, x: 0, duration: 0.4, ease: EASE_HOVER, overwrite: 'auto' });
        } else {
          var offsetX = i < hoveredIdx ? -pushX : pushX;
          var distance = Math.abs(hoveredIdx - i);
          gsap.to(card, {
            x: offsetX,
            duration: 0.4,
            ease: EASE_HOVER,
            delay: distance * 0.05,
            overwrite: 'auto'
          });
        }
      });
    }

    function resetSiblings() {
      if (!entranceDone) return;
      cards.forEach(function (card) {
        gsap.killTweensOf(card);
        var rot = parseFloat(card.getAttribute('data-rot') || '0');
        gsap.to(card, { x: 0, rotation: rot, duration: 0.4, ease: EASE_HOVER, overwrite: 'auto' });
      });
    }

    cards.forEach(function (card, i) {
      card.addEventListener('mouseenter', function () {
        pushSiblings(i);
      });
      card.addEventListener('mouseleave', resetSiblings);
    });
  });
})();

